import Backpack from '@/src/assets/svgs/Backpack'
import { ConfirmationNumberOutlined, Inventory2, Luggage } from '@mui/icons-material'
import { Box, Tooltip, Typography } from '@mui/material'

const SegmentBaggage = ({
    cab,
    cib,
    freeText,
    additionalBaggage,
    fareType,
    additionalBaggageLabel,
    fareTypeLabel,
    viewBaggageCta,
    extrasCta,
    cabinBaggageCta,
    checkinBaggageCta
}: {
    cab: string
    cib: string
    freeText: string
    additionalBaggage?: string
    fareType?: string
    additionalBaggageLabel: string
    fareTypeLabel: string
    viewBaggageCta: string
    extrasCta: string
    cabinBaggageCta: string
    checkinBaggageCta: string
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                fontSize: 12,
                color: 'textColors.secondary',
                alignItems: 'flex-start',
                marginTop: 0.5
            }}
        >
            {freeText ? (
                <Tooltip
                    title={freeText}
                >
                    <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                        {viewBaggageCta}
                    </Typography>
                </Tooltip>
            ) : (
                <>
                    {fareType && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ConfirmationNumberOutlined sx={{ fontSize: 16, mr: 0.5 }} />
                            <Typography component="span" sx={{ fontSize: 12, color: 'text.secondary' }}>
                                {fareTypeLabel}:{' '}
                            </Typography>
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                                {fareType}
                            </Typography>
                        </Box>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Luggage sx={{ fontSize: 16, mr: 0.5 }} />
                        {checkinBaggageCta}:{' '}
                        <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                            {cib}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Backpack sx={{ fontSize: 16, mr: 0.5 }} />
                        {cabinBaggageCta}:{' '}
                        <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                            {cab}
                        </Typography>
                    </Box>
                    {additionalBaggage && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Inventory2 sx={{ fontSize: 12, ml: 0.2, mr: 0.7 }} />
                            {extrasCta}:{' '}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600 }}>
                                {`${additionalBaggageLabel}: ${additionalBaggage}`}
                            </Typography>
                        </Box>
                    )}
                </>
            )}
        </Box>
    )
}

export default SegmentBaggage
